export default __webpack_public_path__ + "navigation-examples-predictive-caching-1200-7f8c3b2137ab6f5cb6457108fa044708.webp";